import { Session } from 'types/session';

import { SessionDomain } from './domain';

export const loginEvent = SessionDomain.createEvent<Session>();
export const logoutEvent = SessionDomain.createEvent();
